import React from 'react'

import CoverImage from 'components/shared/CoverImage'
import { Title, Label } from 'components/typo'

import css from './styles.module.scss'

const EventCardContent = ({ forwardRef, image, title, date }) => {
  const eventDate = date && new Date(date)

  return (
    <div ref={forwardRef} className={css.EventCardContent}>
      {image && (
        <div className={css.pictureWrapper}>
          <CoverImage className={css.picture} {...image} />
        </div>
      )}

      <div className={css.infos}>
        {eventDate && (
          <div className={css.dateWrapper}>
            <Label className={css.month} theme="white">
              {eventDate.toLocaleDateString('en-US', { month: 'long' })}
            </Label>
            <span className={css.day}>{eventDate.getDay()}</span>
          </div>
        )}
        {title && (
          <Title tag="h4" className={css.name}>
            {title}
          </Title>
        )}
      </div>
    </div>
  )
}

export default EventCardContent
